/* eslint-disable no-underscore-dangle */
class SubjectManagerPopupController {
	constructor($log, $timeout, iSpiroService, subjectManagerService, loadingIndicatorService,
		signatureService, appI18n, appConfig, $stateParams, $q,
		ertBasePopupService, notificationService, userService, configurationService, eproService) {
		'ngInject';
		this.$log = $log;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.iSpiroService = iSpiroService;
		this.subjectManagerService = subjectManagerService;
		this.loadingIndicatorService = loadingIndicatorService;
		this.signatureService = signatureService;
		this.ertBasePopupService = ertBasePopupService;
		this.notificationService = notificationService;
		this.userService = userService;
		this.appI18n = appI18n;
		this.appConfig = appConfig;
		this.configurationService = configurationService;
		this.eproService = eproService;
		this.$q = $q;
		this.onlineHelpId = 'MSP3.ClinicalData.ISpiro.DispenseDevice';
		this.isEditMode = false;
		this.isLoading = false;
		this.$API = null;
		this.subjectManagerForm = null;
		this.state = null;
		this.hasDOB = false;
		this.hasAge = false;
		this.dobIsInFutureMsg = null;
		this.errors = {
			genericError: false
		};

		// SITES
		this.sites = null;
		this.selectedSite = null;
		this.sitesOptions = {
			label: 'app.common.siteId',
			disabled: false,
			id: 'sitesDropdown',
			required: true,
			placeholder: 'clinicaldata.subject.create.selectSite',
			uiValue: 'displaySiteName'
		};

		// SUBJECTS
		this.subjects = [];
		this.selectedSubject = null;
		this.subjectNumber = null;
		this.subjectsOptions = {
			label: 'app.common.subjectKey',
			id: 'subjectsDropdown',
			required: true,
			placeholder: 'clinicaldata.subject.i-spiro.close-dispense.selectSubject',
			uiValue: 'subjectKey'
		};

		// SUBJECT FIELDS
		this.subjectFields = null;

		// PARAMETERS VALIDATION
		this.onlyNumeric = {
			fn: (inputValue) => {
				if (!inputValue) { return true; }
				return !isNaN(Number(inputValue));
			}
		};

		this.getMinMaxValidator = (field) => {
			return {
				fn: (inputValue) => {
					if (!inputValue) { return true; }
					return !(inputValue < +field.minimumValue || inputValue > +field.maximumValue);
				}
			};
		};

		this.getNumberOfDecimalsValidator = (field) => {
			return {
				fn: (inputValue) => {
					if (!inputValue) { return true; }

					const decimals = field.numberOfDecimals;
					const fraction = `${inputValue}`.split('.');
					const decimalsNr = fraction[1] && fraction[1].length;

					return !(decimalsNr && decimalsNr > decimals);
				}
			};
		};

		this.isRequiredText = 'clinicaldata.subject.create.errors.required.general';
		this.onlyNumericText = 'clinicaldata.subject.create.validation.onlyNumeric';
		 
		this.getMinMaxMessage = (field) => {
			return this.appI18n.translateImmediate('clinicaldata.subject.create.validation.minMaxText').supplant({
				minValue: field.minimumValue,
				maxValue: field.maximumValue
			});
		};

		this.getNumberOfDecimalsText = (field) => {
			return this.appI18n.translateImmediate('clinicaldata.subject.create.validation.numberOfDecimals').supplant({
				numberOfDecimals: field.numberOfDecimals
			});
		};

		this.getNumberOfDecimalsValidationText = (field) => {
			return field.numberOfDecimals > 0
			? (this.appI18n.translateImmediate('clinicaldata.subject.create.validation.withDecimalMessage')
			.supplant({
				numberOfDecimals: field.numberOfDecimals
			})) : this.appI18n.translateImmediate('clinicaldata.subject.create.validation.withoutDecimalMessage');
		};

		// ACTION BUTTONS
		this.signSubmitBtn = {
			action: () => {
				this.initiateSignature();
			},
			cssClass: '-es-primary',
			displayName: 'app.buttons.sign-submit',
			isDisabled: false,
			type: 'submit'
		};

		this.cancelBtn = {
			action: () => {
				this.$API.close();
			},
			displayName: 'app.buttons.cancel',
			isDisabled: false
		};

		this.actions = [this.signSubmitBtn, this.cancelBtn];
		this.isEditBlocked = false;
	}

	$onInit() {
		this.$log = this.$log.getInstance('SubjectManagementPopupController');
		this.$log.debug('loaded');
		
		// Initialize study configuration for cough data type check
		this.initStudyConfiguration();
		this.eproService.getProtocolSetupLabels().then((response) => {
			const siteLabel = response.data.find(l => l.fieldKey === 'IT_9')?.dfcLabel;
			if (siteLabel) {
				this.sitesOptions.label = siteLabel;
			}
		});
		this.$API = this.setApi();
		this.componentReady && this.componentReady({ $API: this.$API });

		if (this.$stateParams.signKey) {
			const state = this.signatureService.getState(this.$stateParams.signKey);

			if (state) {
				if (state.sigType === this.getSignatureType()) {
					if (this.signatureService.checkSignatureWorkflow(this.$stateParams.signKey,
						this.$stateParams.tokenId,
						this.doSubmit, this.onSignatureCancel, this)) {
						return;
					}
				}
			}
		}
	}

	
	setFormTitle(isEdit) {
		this.popupHeading = isEdit
						? 'clinicaldata.subject.subjectManagement.edit-title'
						: 'clinicaldata.subject.subjectManagement.create-title';
		this.isEditMode = isEdit;
	}

	makeFormsDirty() {
		angular.forEach(this.subjectManagerForm.$error.required, (field) => {
			field.$setDirty();
		});
		this.subjectManagerForm.showValidation = true;
		this.validateAge();
		this.validateHeight();
		this.validateWeight();
	}

	initiateSignature() {
		if (this.errors.genericError) {
			return;
		}

		// added validateHeight() explicity as this.subjectManagerForm.$invalid does not accounts for height and weight validation
		if (this.subjectManagerForm.$invalid || !this.validateHeight() || !this.validateWeight()) {
			this.makeFormsDirty();
			return;
		}

		this.updateHeightModelValue();
		this.updateWeightModelValue();

		if (!this.validateHeight() || !this.validateAge() || !this.validateWeight()) {
			return;
		}

		const sigType = this.getSignatureType();

		// save state for signature process
		this.state = {
			_openPopupParams: {
				preselectedSite: this.preselectedSiteId,
				preselectedSubject: this.preselectedSubjectId,
			},
			_sites: this.sites,
			selectedSite: this.selectedSite,

			_subjects: this.subjects,
			selectedSubject: this.selectedSubject,

			initials: this.initialsValue,
			dob: this.dobValue,
			height: this.heightValue,
			weight: this.weightValue,
			age: this.ageValue,
			dobForAge: this.dobForAgeValue,
			subjectId: this.subjectIdValue,

			subjectId2: this.subjectId2Value,
			subjectNumber: this.subjectNumber,
			_ethnicities: this.ethnicities,
			selectedEthn: this.selectedEthn,

			_genders: this.genders,
			selectedGender: this.selectedGender,
			isRemoteAction: this.isRemoteAction,
			isEditBlocked: this.isEditBlocked,
			sigType,
		};

		this.additionalInfo = {
			action: this.isCreatingSubject()
				? this.appI18n.translateImmediate(
						'signature.action.createSubject'
				  )
				: this.appI18n.translateImmediate(
						'signature.action.editSubject'
				  ),
			infoKey1: this.appI18n.translateImmediate('signature.info.site'),
			infoValue1: this.selectedSite.sponsorSiteId,
			infoKey2: this.appI18n.translateImmediate('signature.info.subject'),
			infoValue2: this.isCreatingSubject()
				? this.subjectIdValue
				: this.selectedSubject.subjectKey,
		};

		this.signatureService.sign(sigType, this.additionalInfo, this.state);
	}
	
	getSignatureType() {
		return this.appConfig.sigType.subjectManagerCreateSubject;
	}

	doSubmit(state) {
		const action = this.chooseSubmitAction(state);

		if (!action) {
			return;
		}

		this.loadingIndicatorService.show();
		action.then((resp) => {
			if (resp.data.isValidationError) {
				const msg = (resp.data && resp.data.responseMessageTranslationKey)
					  ? resp.data.responseMessageTranslationKey
					  : 'clinicaldata.subject.create.errors.genericSaveError';
				this.notificationService.showError(this.appI18n.translateImmediate(msg));
				this.open = true;
				this.restorePopupState(state);
			} else {
				const isCreateSubject = (state.selectedSubject === null || state.selectedSubject.subjectId === null);
				const messageKey = isCreateSubject
								 ? 'clinicaldata.subject.create.saveDelay'
								 : 'clinicaldata.subject.create.saveDelayUpdate';
				this.showSaveUpdateDelayWarning(messageKey);
			}
		}, (/*error*/) => {
			this.open = true;
			this.restorePopupState(state);
		}).finally(() => {
			this.loadingIndicatorService.hide();
		});
	}

	showSaveUpdateDelayWarning(messageKey) {
		this.appI18n.translate([messageKey]).then((translations) => {
			const msg = translations[messageKey];
			this.notificationService.showSuccess(msg);
		});
	}

	chooseSubmitAction(state) {
		let action;
		const isCreateSubject = (state.selectedSubject === null || state.selectedSubject.subjectId === null);
		if (isCreateSubject) {
			const payload = this.generateCreateRequestPayload(state);
			action = this.subjectManagerService.createSubject(payload);
		} else {
			const payload = this.generateUpdateRequestPayload(state);
			action = this.subjectManagerService.updateSubject(payload, state.selectedSubject.subjectId);
		}
		return action;
	}

	onSignatureCancel(state) {
		this.$timeout(() => {
			this.open = true;
			this.restorePopupState(state);
		});
	}

	restorePopupState(state) {

		if (state._openPopupParams.preselectedSite) {
			this.sitesOptions.disabled = true;
		}
		if (state._openPopupParams.preselectedSubject) {
			this.subjectsOptions.disabled = true;
		}
		this.sites = state._sites;
		this.selectedSite = state.selectedSite;

		this.subjects = state._subjects;
		this.selectedSubject = state.selectedSubject;

		let getSubjectInfo;

		this.isLoading = true;
		if (this.isCreatingSubject()) {
			this.setFormTitle(false);
			getSubjectInfo = this.getCreateSubjectInfo(this.selectedSite.countryId, this.selectedSite.siteId);
			
		} else {
			this.setFormTitle(true);
			getSubjectInfo = this.getEditSubjectInfo(this.selectedSite.countryId, this.selectedSite.siteId,
				this.selectedSubject.subjectId);
		}

		return getSubjectInfo.then((data) => {

			this.subjectFields = data.fields;
			this.ethnicities = data.ethnicities;
			this.isEditBlocked = state.isEditBlocked;
			this.generateSubjectFields(this.subjectFields, this.selectedSite.sponsorSiteId);
			this.initialsValue = state.initials;
			this.dobValue = state.dob;
			this.subjectIdValue = state.subjectId;
			this.subjectId2Value = state.subjectId2;
			this.selectedEthn = state.selectedEthn;
			this.selectedGender = state.selectedGender;
			this.ageValue = state.age;
			this.heightValue = state.height;
			this.weightValue = state.weight;
			this.dobForAgeValue = state.dobForAge;
			this.preLoadHeight(this.subjectFields, this.heightValue);
			this.preLoadWeight(this.subjectFields, this.weightValue);
			this.isLoading = false;
		});
	}

	generateCreateRequestPayload(state) {
		return {
			siteId: +state.selectedSite.siteId, //number
			subjectId1: state.subjectId,
			subjectId2: state.subjectId2,
			gender: state.selectedGender ? state.selectedGender.name : null,
			genderId: state.selectedGender ? state.selectedGender.id : null,
			ethnicityName: state.selectedEthn ? state.selectedEthn.name : null,
			ethnicityId: state.selectedEthn ? state.selectedEthn.id : null,
			dob: state.dob,
			dateOfBirth: state.dob,
			initials: state.initials,
			signKey: this.$stateParams.signKey,
			signToken: this.$stateParams.tokenId,
			age: state.age,
			height: state.height,
			weight: state.weight,
			isEditBlocked: this.isEditBlocked
		};
	}

	generateUpdateRequestPayload(state) {
		return {
			siteId: +state.selectedSite.siteId, //number
			subjectId1: state.subjectId,
			subjectId2: state.subjectId2,
			signKey: this.$stateParams.signKey,
			signToken: this.$stateParams.tokenId,
			age: state.age,
			height: state.height,
			weight: state.weight,
			dob: state.dob,
			initials: state.initials,
			gender: state.selectedGender ? state.selectedGender.name : null,
			genderId: state.selectedGender ? state.selectedGender.id : null,
			ethnicityName: state.selectedEthn ? state.selectedEthn.name : null,
			ethnicityId: state.selectedEthn ? state.selectedEthn.id : null,
			isEditBlocked: this.isEditBlocked
		};
	}

	setApi() {
		const $API = {
			open: (countryId, siteId, subjectId, displaySiteName, subjectKey, isEdit) => {
				this.errors.genericError = false;
				this.loadingIndicatorService.show();
				this.setFormTitle(isEdit);
				this.isRemoteAction = true;
				this.countryId = countryId;
				if (siteId && subjectId) {
					this.hideContentMessage = true;
					this.preselectedSiteId = siteId;
					this.selectedSite = {
						countryId: +countryId,
						siteId: +siteId,
						displaySiteName
					};
					this.sites = [this.selectedSite];
					this.sitesOptions.disabled = true;

					this.preselectedSubjectId = subjectId;
					this.selectedSubject = {
						subjectKey,
						subjectId
					};
					this.subjects = [this.selectedSubject];
					this.subjectsOptions.disabled = true;

					this.proceedWithEditSubject(this.selectedSubject).then(() => {
						this.open = true;
					}).finally(() => {
						this.loadingIndicatorService.hide();
					});

				} else {
					this.hideContentMessage = false;
					this.onPopupShow().then(() => {
						siteId && this.preselectSite(siteId.toString());
						this.open = true;
					}).finally(() => {
						this.loadingIndicatorService.hide();
					});
				}

			},
			close: () => {
				this.state = null;
				this.sites = null;
				this.preselectedSiteId = null;
				this.sitesOptions.disabled = false;
				this.subjectsOptions.disabled = false;
				this.subjects = [];
				this.selectedSite = null;
				this.selectedSubject = null;
				this.resetDemographics();
				this.open = false;
			}
		};

		return $API;
	}

	onPopupShow() {
		return this.$q.all([
			this.subjectManagerService.getSitesMinimal(null, this.countryId).then((res) => {
				this.sites = res.data;
			}),
			this.appI18n.translate(['clinicaldata.subject.buttons.create']).then(
				(res) => {
					this.translations = res;
				}
			),
			this.userService.getUserHasPermission(
				this.appConfig.businessPermissions.iSpiroCreateSubject)
				.then((res) => {
					this.canCreateSubjects = res;
				})
		]);
	}

	getEditSubjectInfo(countryId, siteId, subjectId) {
		return this.subjectManagerService.getEditSubjectData(countryId, siteId, subjectId).then((res) => {
			return res.data;
		});
	}

	getCreateSubjectInfo(country, site) {
		return this.subjectManagerService.getCreateSubjectData(country, site).then((res) => {
			return res.data;
		}, (error) => {
			this.errors.genericError = true;
			this.isLoading = false;
			return error;
		});
	}

	cancelAction() {
		this.$API.close();
	}

	onSiteChange(newVal) {

		this.resetDemographics();
		this.selectedSite = newVal;

		if (!newVal) {
			this.subjects = [];
			return;
		}

		if (this.popupHeading === 'clinicaldata.subject.subjectManagement.create-title') {
			this.proceedWithCreateSubject();
		} else {
		this.isLoading = true;
		this.getSubjects(newVal).then((res) => {
			this.subjects = res.subjects;
			this.isEditBlocked = res.config.blockSubjectCreation;
		}).finally(() => {
			this.isLoading = false;
		});
	}
	}

	getSubjects(newVal) {
		return this.iSpiroService.getSubjects(
			newVal.countryId, newVal.siteId,
			this.appConfig.iSpiroActionId.dispense)
			.then((res) => {
				const subjects = res.data.subjects;
				const config = res.data.config;
				const blockSubjectCreation = config.blockSubjectCreation; //This is a flag to block subject creation
				if (this.canCreateSubjects && !blockSubjectCreation) {
					subjects.unshift({
						'subjectKey': this.translations['clinicaldata.subject.buttons.create'],
						subjectId: null
					});
				}

				if (subjects && subjects.length > 0) {
					this.subjectsOptions.placeholder = 'clinicaldata.subject.i-spiro.close-dispense.selectSubject';
				} else {
					this.subjectsOptions.placeholder = 'clinicaldata.subject.i-spiro.close-dispense.noSubject';
				}
				return res.data;
			});
	}

	preselectSite(siteId) {
		this.preselectedSiteId = siteId;
		const siteToSelect = this.sites.find((s) => {
			return s.siteId === siteId;
		});

		this.selectedSite = siteToSelect || null;
		if (this.selectedSite) {
			this.sitesOptions.disabled = true;
			this.onSiteChange(this.selectedSite);
		}
	}

	proceedWithEditSubject(newVal) {
		this.isLoading = true;
		return this.getEditSubjectInfo(this.selectedSite.countryId, this.selectedSite.siteId, newVal.subjectId)
			.then((data) => {
				this.subjectFields = data.fields;
				this.ethnicities = data.ethnicities;
				this.isEditBlocked = data.blockSubjectCreation;
				this.generateSubjectFields(this.subjectFields, this.selectedSite.sponsorSiteId);
				this.initEditSubjectFields(data.subjectData, this.subjectFields);
				this.isLoading = false;
			}, (/*error*/) => {
				this.isLoading = false;
			});
	}

	proceedWithCreateSubject() {
		this.isLoading = true;
		this.getCreateSubjectInfo(this.selectedSite.countryId, this.selectedSite.siteId).then((data) => {
			this.subjectFields = data.fields;
			this.ethnicities = data.ethnicities;
			this.generateSubjectFields(this.subjectFields, this.selectedSite.sponsorSiteId);
			this.isLoading = false;
		});
	}

	initEditSubjectFields(subjectData, subjectFields) {

		this.initialsValue = subjectData.initials;

		this.dobValue = subjectData.dob;
		this.ageValue = subjectData.age;
		this.heightValue = subjectData.height;
		this.weightValue = subjectData.weight;

		this.subjectIdValue = subjectData.subjectId1;
		this.subjectId2Value = subjectData.subjectId2;
		this.subjectNumber = subjectData.subjectNumber;

		if (this.ethnicities) {
			this.selectedEthn = this.ethnicities.find((eth) => {
				return eth.id === subjectData.ethnicityId;
			});
		}
		if (this.genders) {
			this.selectedGender = this.genders.find((gen) => {
				return +gen.id === +subjectData.genderId;
			});
		}
		
		this.preLoadHeight(subjectFields, this.heightValue);
		this.preLoadWeight(subjectFields, this.weightValue);
	}

	generateSubjectFields(fieldsData, sponsorSiteId) {
		this.hasDOB = this.hasFieldsHaveDateOfBirth(fieldsData);
		this.hasAge = this.hasFieldsHaveAge(fieldsData);

		fieldsData.forEach((field) => {
			switch (+field.id) {
				case this.appConfig.demographics.initials:
					this.initInitialsField(field);
					break;
				case this.appConfig.demographics.dob:
					this.initDOBField(field);
					break;
				case this.appConfig.demographics.subjectId1:
					this.initSubjectIdField(field, sponsorSiteId);
					break;
				case this.appConfig.demographics.subjectId2:
					this.initSubjectID2Field(field);
					break;
				case this.appConfig.demographics.ethnicity:
					this.initEthnicityField(field);
					break;
				case this.appConfig.demographics.gender:
					this.initGender(field);
					break;
				case this.appConfig.demographics.height:
					this.initHeight(field);
					break;
				case this.appConfig.demographics.weight:
					this.initWeight(field);
					break;
				case this.appConfig.demographics.age:
					this.initAge(field);
					break;
					
			}
		});
	}

	initParameterField(field) {
		this.parameterFields.push(field);
	}

	canEditParameters() {
		return false;
	}

	hasFieldsHaveDateOfBirth(fields) {
		const res = fields.some((p) => {
			return +p.id === this.appConfig.demographics.dob;
		});

		return res;
	}

	hasFieldsHaveAge(fields) {
		const res = fields.some((p) => {
			return +p.id === this.appConfig.demographics.age;
		});

		return res;
	}


	initInitialsField(field) {
		this.initialsValue = null;
		this.initialsOptions = {
			label: field.label,
			id: 'initialsInput',
			required: field.isRequired && !this.isEditBlocked,
			disabled: field.isReadOnly && !this.isCreatingSubject() || this.isEditBlocked,
			type: 'text',
			placeholder: '',
			fieldFormatHint: field.formatHint,
			validators: {
				inputFormat: {
					fn: (inputValue) => {
						if (!inputValue) {
							return true;
						}
						return this.validateFormat(inputValue, field);
					}
				}
			}
		};
	}

	initDOBField(field) {
		if (this.hasAge && this.hasDOB) {
			return;
		}
		this.dobValue = null;
		this.dobOptions = {
			label: field.label,
			id: 'dobInput',
			required: field.isRequired && !this.isEditBlocked,
			disabled: field.isReadOnly && !this.isCreatingSubject() || this.isEditBlocked,
			type: 'text',
			placeholder: field.isPartialDob ? 'MMM-YYYY/YYYY' : 'DD-MMM-YYYY',
			fieldFormatHint: field.formatHint,
			validators: {
				inputFormat: {
					fn: (inputValue) => {
						if (!inputValue) { return true; }
						return this.validateFormat(inputValue, field);
					}
				},
				dobIsInFuture: {
					fn: (inputValue) => {
						if (!inputValue) { return true; }
						if (this.dateIsInFuture(inputValue)) {
							this.dobIsInFutureMsg = this.appI18n.translateImmediate('app.messages.dobInPast');
							return false;
						}
						return true;
					}
				}
			}
		};
	}

	initSubjectIdField(field, sponsorSiteId) {
		this.subjectIdValue = null;
		this.subjectIdOptions = {
			label: field.label,
			id: 'subjectIdInput',
			required: field.isRequired && !this.isEditBlocked,
			disabled: !this.isCreatingSubject() || this.isEditBlocked,
			type: 'text',
			placeholder: '',
			fieldFormatHint: field.formatHint,
			validators: {
				siteIdPrefix: {
					fn: (inputValue) => {
						if (!inputValue || !field.isSitePrefix || !sponsorSiteId ||
							!this.isCreatingSubject()) { return true; }
						return inputValue.startsWith(sponsorSiteId);
					}
				},
				inputFormat: {
					fn: (inputValue) => {
						if (!inputValue) { return true; }
						return this.validateFormat(inputValue.trim(), field);
					}
				}
			}
		};

		if (field.isSitePrefix && sponsorSiteId && this.isCreatingSubject()) {
			this.subjectIdValue = sponsorSiteId;
		}
	}


	initSubjectID2Field(field) {
		this.subjectId2Value = null;
		this.subjectId2Options = {
			label: field.label,
			id: 'subjectId2Input',
			required: field.isRequired && !this.isEditBlocked,
			disabled: field.isReadOnly && !this.isCreatingSubject() || this.isEditBlocked,
			type: 'text',
			placeholder: '',
			fieldFormatHint: field.formatHint,
			validators: {
				inputFormat: {
					fn: (inputValue) => {
						if (!inputValue) { return true; }
						return this.validateFormat(inputValue, field);
					}
				}
			}
		};
	}

	initEthnicityField(field) {
		this.selectedEthn = null;
		this.ethnOptions = {
			label: field.label,
			disabled: field.isReadOnly && !this.isCreatingSubject() || this.isEditBlocked,
			id: 'ethnDropdown',
			required: field.isRequired,
			placeholder: 'clinicaldata.subject.create.selectEthnicity',
			uiValue: 'name'
		};

		this.onEthnChange = (newVal) => {
			this.selectedEthn = newVal;
		};
	}

	initGender(field) {
		this.selectedGender = null;
		this.genders = [{ name: 'Male', id: 1 }, { name: 'Female', id: 2 }];
		this.genderOptions = {
			label: field.label,
			disabled: field.isReadOnly && !this.isCreatingSubject() || this.isEditBlocked,
			id: 'genderDropdown',
			required: field.isRequired && !this.isEditBlocked,
			placeholder: '',
			uiValue: 'name'
		};

		this.onGenderChange = (newVal) => {
			this.selectedGender = newVal;
		};
	}

	transformHeightValidationMessage(field) {
		const msg = field.formatHint;
		return `${msg.substring(0, 21)}  ${this.getNumberOfDecimalsValidationText(field)}
				${msg.substring(21, msg.length)}`;
	}

	initHeight(field) {
		this.heightValue = null;
		this.heightInInchValue = null;
		this.heightInCmValue = null;
		this.isHeightValid = true;
		this.heightOptions = {
			label: field.label,
			required: field.isRequired && !this.isEditBlocked,
			fieldFormatHint: this.transformHeightValidationMessage(field),
			inches: {
				label: 'in',
				id: 'inputHeight_in',
				disabled:
					(field.isReadOnly && !this.isCreatingSubject()) ||
					this.isEditBlocked,
			},
			centimeters: {
				label: 'cm',
				id: 'inputHeight_cm',
				disabled:
					(field.isReadOnly && !this.isCreatingSubject()) ||
					this.isEditBlocked,
			},
		};

		this.OnCmHeightChanges = (newVal) => {
			if (!newVal) {
				this.heightInInchValue = null;
				this.heightValue = null;
				return;
			}
			this.isHeightRequiredValid = false;
			this.heightInInchValue = this.convertCmToInches(
				newVal,
				field.numberOfDecimals
			);
			this.heightValue = `${newVal}cm`;
			if (!this.validateDecimalsForHeight(field, newVal)) {
				this.isHeightValid = false;
				return;
			}
			this.validateHeightRange(field);
		};

		this.OnInchHeightChanges = (newVal) => {
			if (!newVal) {
				this.heightInCmValue = null;
				this.heightValue = null;
				return;
			}
			this.isHeightRequiredValid = false;
			this.heightInCmValue = this.convertInchesToCm(
				newVal,
				field.numberOfDecimals
			);
			this.validateHeightRange(field);
		};
	}
	updateHeightModelValue() {

		if (!this.heightInCmValue || !this.heightInInchValue) {
			return;
		}

		const heightField = this.subjectFields.find((field) => {
			return (+(field.id) === this.appConfig.demographics.height);
		});

		if (!heightField) {
			return;
		}
		
		this.heightInInchValue = this.roundOffHeight(this.heightInInchValue, heightField.numberOfDecimals);
		this.heightInCmValue = this.roundOffHeight(this.heightInCmValue, heightField.numberOfDecimals);

		if (heightField.measuringUnit === 'in') {
			this.heightValue = `${this.heightInInchValue}${heightField.measuringUnit}`;
		} else {
			this.heightValue = `${this.heightInCmValue}cm`;
		}
	}


	countDecimals(value) {
		if (!value || value.toString() === '') {
			return 0;
		}
		return value.toString().includes('.') ? value.toString().split('.')[1].length || 0 : 0;
	}

	validateDecimalsForHeight(field, value) {
		const decimals = this.countDecimals(value);
		return (decimals === field.numberOfDecimals);
	}

	isHeightValidOnSubmit() {
		const heightField = this.subjectFields.find((field) => {
			return (+(field.id) === this.appConfig.demographics.height);
		});
		/*if height field is not present then return true as height is valid*/
		if (!heightField) {
			return true;
		}
		
		return this.validateHeightRange(heightField);
	}

	isAgeValidOnSubmit() {
		const ageField = this.getFieldConfig(this.appConfig.demographics.age);
		/*if the age field is not present then return true*/
		if (!ageField) {
			return true;
		}
		return this.validateRange(ageField, +(this.ageValue));
	}

	initStudyConfiguration() {
		this.configurationService.getUserStudySettings().then(response => {
			if (response.data && response.data.studyConfig) {
				this.studyConfig = response.data.studyConfig;
			}
		}).catch(error => {
			this.$log.debug('Error loading study configuration:', error);
		});
	}

	isCoughAllowed() {
		return this.selectedSite && this.studyConfig && this.studyConfig.hasCough;
	}

	validateHeightRange(field) {
		this.isHeightValid = this.validateRange(field, this.heightInCmValue) &&
							this.validateDecimalsForHeight(field, this.heightInCmValue);
		return this.isHeightValid;
	}

	/*
		set isHeightValid to true if editing is blocked OR
		set isHeightValid to true if height is empty but optional OR
		set isHeightValid to true if height is valid
	*/
	validateHeight() {
		const isEmptyButOptional = this.isHeightEmptyButOptional();
		const isValidOnSubmit = this.isHeightValidOnSubmit();
		return this.isHeightValid = this.isEditBlocked || isEmptyButOptional || isValidOnSubmit;
	}

	/*
	// Updated isHeightEmptyButOptional to explicitly return true only if heightField.isRequired is false 
	// and this.heightValue is null; otherwise, returns false for all other cases.
	*/
	isHeightEmptyButOptional() {
		const heightField = this.getFieldConfig(this.appConfig.demographics.height);
		if (!heightField) {
			return false;
		}
		if (!heightField.isRequired && !this.heightValue) {
			return true;
		}
		return false;
	}

	/*
		set ageIsValid to true if editing is blocked OR
		set ageIsValid to true if age is empty but optional OR
		set ageIsValid to true if age is valid
	*/
	validateAge() {
		const isEmptyButOptional = this.isAgeEmptyButOptional();
		const isValidOnSubmit = this.isAgeValidOnSubmit();
		return this.ageIsValid = this.isEditBlocked ||
								isEmptyButOptional ||
								isValidOnSubmit;
	}

	isAgeEmptyButOptional() {
		const ageField = this.getFieldConfig(this.appConfig.demographics.age);
		return ageField && !ageField.isRequired && !this.ageValue;
	}


	convertInchesToCm(inches, decimal) {
		const cmPerInch = 2.54;
		return this.roundOffHeight((Number(inches) * cmPerInch), decimal);
	}
	convertCmToInches(cm, decimal) {
		const inchPerCm = (1 / 2.54);
		return this.roundOffHeight((Number(cm) * inchPerCm), decimal);
	}

	roundOffHeight(val, decimals) {
		return ((Number.parseFloat(val)).toFixed(decimals));
	}

	preLoadHeight(fieldData, heightValue) {

		const heightField = fieldData.find((field) => {
			return (+(field.id) === this.appConfig.demographics.height);
		});

		if (heightField && heightValue) {
			if (heightValue.includes('in')) {
				this.heightInInchValue = heightValue.substring(0, heightValue.length - 2);
				this.heightInCmValue = this.convertInchesToCm(this.heightInInchValue, heightField.numberOfDecimals);
			} else {
				//for cm or nothing
				this.heightInCmValue = (heightValue && heightValue.includes('cm'))
										? heightValue.substring(0, heightValue.length - 2) : heightValue;
				this.heightInInchValue = this.convertCmToInches(this.heightInCmValue, heightField.numberOfDecimals);
			}
		}
	}

	// ===== WEIGHT IMPLEMENTATION =====
	initWeight(field) {
		this.weightValue = null;
		this.weightInKgValue = null;
		this.weightInLbsValue = null;
		this.isWeightValid = true;
		this.isWeightRequiredValid = false;
		this.weightOptions = {
			label: field.label,
			required: field.isRequired && !this.isEditBlocked,
			fieldFormatHint: this.transformWeightValidationMessage(field),
			kilograms: {
				label: 'kg',
				id: 'inputWeight_kg',
				disabled:
					(field.isReadOnly && !this.isCreatingSubject()) ||
					this.isEditBlocked,
			},
			pounds: {
				label: 'lbs',
				id: 'inputWeight_lbs',
				disabled:
					(field.isReadOnly && !this.isCreatingSubject()) ||
					this.isEditBlocked,
			},
		};

		this.OnKgWeightChanges = (newVal) => {
			if (!newVal) {
				this.weightInLbsValue = null;
				this.weightValue = null;
				return;
			}
			this.isWeightRequiredValid = false;
			this.weightInLbsValue = this.convertKgToLbs(
				newVal,
				field.numberOfDecimals
			);
			this.weightValue = `${newVal}kg`;
			if (!this.validateDecimalsForWeight(field, newVal)) {
				this.isWeightValid = false;
				return;
			}
			this.validateWeightRange(field);
		};

		this.OnLbsWeightChanges = (newVal) => {
			if (!newVal) {
				this.weightInKgValue = null;
				this.weightValue = null;
				return;
			}
			this.isWeightRequiredValid = false;
			this.weightInKgValue = this.convertLbsToKg(
				newVal,
				field.numberOfDecimals
			);
			// this.weightValue = `${newVal}lbs`;
			// if (!this.validateDecimalsForWeight(field, newVal)) {
			// 	this.isWeightValid = false;
			// 	return;
			// }
			this.validateWeightRange(field);
		};
	}

	updateWeightModelValue() {
		if (!this.weightInKgValue || !this.weightInLbsValue) {
			return;
		}

		const weightField = this.subjectFields.find((field) => {
			return (+(field.id) === this.appConfig.demographics.weight);
		});

		if (!weightField) {
			return;
		}
		
		this.weightInLbsValue = this.roundOffWeight(this.weightInLbsValue, weightField.numberOfDecimals);
		this.weightInKgValue = this.roundOffWeight(this.weightInKgValue, weightField.numberOfDecimals);

		if (weightField.measuringUnit === 'lbs') {
			this.weightValue = `${this.weightInLbsValue}${weightField.measuringUnit}`;
		} else {
			this.weightValue = `${this.weightInKgValue}kg`;
		}
	}

	transformWeightValidationMessage(field) {
		return field.formatHint ? `${field.formatHint}` : 'Invalid weight format';
	}

	validateDecimalsForWeight(field, value) {
		const decimals = this.countDecimals(value);
		return (decimals === field.numberOfDecimals);
	}

	isWeightValidOnSubmit() {
		const weightField = this.subjectFields.find((field) => {
			return (+(field.id) === this.appConfig.demographics.weight);
		});
		/*if weight field is not present then return true as weight is valid*/
		if (!weightField) {
			return true;
		}
		
		return this.validateWeightRange(weightField);
	}

	validateWeightRange(field) {
		this.isWeightValid = this.validateRange(field, this.weightInKgValue) &&
							this.validateDecimalsForWeight(field, this.weightInKgValue);
		return this.isWeightValid;
	}

	/*
		set isWeightValid to true if editing is blocked OR
		set isWeightValid to true if weight is empty but optional OR
		set isWeightValid to true if weight is valid
	*/
	validateWeight() {
		const isEmptyButOptional = this.isWeightEmptyButOptional();
		const isValidOnSubmit = this.isWeightValidOnSubmit();
		return this.isWeightValid = this.isEditBlocked || isEmptyButOptional || isValidOnSubmit;
	}

	/*
	// Updated isWeightEmptyButOptional to explicitly return true only if weightField.isRequired is false 
	*/
	isWeightEmptyButOptional() {
		const weightField = this.subjectFields.find((field) => {
			return (+(field.id) === this.appConfig.demographics.weight);
		});
		return weightField && !weightField.isRequired && 
			   (!this.weightInKgValue || !this.weightInLbsValue);
	}

	convertLbsToKg(lbs, decimal) {
		const kgPerLb = 0.453592;
		return this.roundOffWeight((Number(lbs) * kgPerLb), decimal);
	}

	convertKgToLbs(kg, decimal) {
		const lbPerKg = 2.20462;
		return this.roundOffWeight((Number(kg) * lbPerKg), decimal);
	}

	roundOffWeight(val, decimals) {
		return ((Number.parseFloat(val)).toFixed(decimals));
	}

	preLoadWeight(fieldData, weightValue) {
		const weightField = fieldData.find((field) => {
			return (+(field.id) === this.appConfig.demographics.weight);
		});

		if (weightField && weightValue) {
			if (weightValue.includes('lbs')) {
				this.weightInLbsValue = weightValue.substring(0, weightValue.length - 3);
				this.weightInKgValue = this.convertLbsToKg(this.weightInLbsValue, weightField.numberOfDecimals);
			} else {
				//for kg or nothing
				this.weightInKgValue = (weightValue && weightValue.includes('kg'))
										? weightValue.substring(0, weightValue.length - 2) : weightValue;
				this.weightInLbsValue = this.convertKgToLbs(this.weightInKgValue, weightField.numberOfDecimals);
			}
		}
	}
	// ===== END WEIGHT IMPLEMENTATION =====

	initAge(field) {
		this.ageIsValid = true;
		this.isAgeRequiredValid = false;
		this.ageValue = null;
		this.ageOptions = {
			label: field.label,
			// eslint-disable-next-line max-len
			disabled: false, //marking this field as disabled as it is not editable the value will be calculated based on DOB
			id: 'inputAge',
			required: field.isRequired,
			placeholder: '',
			uiValue: 'name',
			type: 'text',
			fieldFormatHint: field.formatHint,
			validators: {
				rangeValidator: {
					fn: (inputValue) => {
						if (!inputValue) {return true;}
						return (this.validateRange(field, inputValue.trim()) &&
						 this.validateFormat(inputValue.trim(), field));
					}
				}
			}
		};
		this.onAgeChange = (newVal) => {
			this.ageValue = newVal;
		};
		this.initDOBForAgeField();
	}

	setReadOnlyDOBForAgeField() {
		if (this.isCreatingSubject()) {
			return false;
		}

		const ageField = this.getFieldConfig(this.appConfig.demographics.age);

		if (!ageField) {
			return false;
		}

		return ageField.isReadOnly;
	}

	initDOBForAgeField() {

		const field = {
			// eslint-disable-next-line max-len
			format: '^((((0?[1-9]|[12][0-9]|3[01])[-]([Jj][Aa][Nn]|[Mm][Aa][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Oo][Cc][Tt]|[Dd][Ee][Cc]))|((0?[1-9]|[12][0-9]|30)[-]([Aa][Pp][Rr]|[Jj][Uu][Nn]|[Ss][Ee][Pp]|[Nn][Oo][Vv]))|((0?[1-9]|[12][0-9])[-]([Ff][Ee][Bb])))[-]((19|20)\\d\\d))?$',
			placeholder: 'DD-MMM-YYYY',
			isRequired: false,
			isReadOnly: this.setReadOnlyDOBForAgeField() || this.isEditBlocked,
			formatHint: this.appI18n.translateImmediate('clinicaldata.subject.create.validation.invalidDateFormat'),
			label: 'DOB'
		};
		
		this.dobForAgeOptions = {
			label: field.label,
			id: 'dobForAgeInput',
			required: field.isRequired,
			disabled: field.isReadOnly,
			type: 'text',
			placeholder: field.placeholder,
			fieldFormatHint: field.formatHint,
			validators: {
				inputFormat: {
					fn: (inputValue) => {
						if (!inputValue) { return true; }
						return this.validateFormat(inputValue, field);
					}
				},
				dobIsInFuture: {
					fn: (inputValue) => {
						if (!inputValue) { return true; }
						if (this.dateIsInFuture(inputValue)) {
							this.dobIsInFutureMsg = this.appI18n.translateImmediate('app.messages.dobInPast');
							return false;
						}
						return true;
					}
				}
			}
		};

		this.onDOBForAgeChange = (newVal) => {
			this.dobForAgeValue = newVal;
			if (this.hasAge && this.hasDOB) {
				this.dobValue = newVal;
			}
			if (!this.dobForAgeValue || !this.validateFormat(this.dobForAgeValue, field)) {
				this.ageValue = null;
				this.ageIsValid = false;
				return;
			}
			this.isAgeRequiredValid = false;
			const ageField = this.getFieldConfig(this.appConfig.demographics.age);
			this.ageValue = this.calculateAge(this.dobForAgeValue, ageField.numberOfDecimals);

			if (!this.validateRange(ageField, +(this.ageValue))) {
				this.ageIsValid = false;
			} else {
				this.ageIsValid = true;
			}
		};
	}

	getAgeDifferenceInYears(birthDate, currentDate) {
		const yearsDiff = currentDate.getFullYear() - birthDate.getFullYear();
		const birthMonth = birthDate.getMonth();
		const currentMonth = currentDate.getMonth();
		const birthDay = birthDate.getDate();
		const currentDay = currentDate.getDate();
		
		if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
		  // If the current date is before the birthdate in the same month or day, subtract a year
		  return yearsDiff - 1;
		}
		return yearsDiff;
	  }
  
	dayOfYear(date) {
		  const start = new Date(date.getFullYear(), 0, 0);
		  const diff = date - start;
		  const oneDay = 1000 * 60 * 60 * 24;
		  return Math.floor(diff / oneDay);
	}
	
  
	calculateAge(dob, allowedDecimals) {
	  const birthDate = new Date(dob); //date of birth of user
	  const currentDate = new Date(); //current date
	  
	  let age = this.calculateDifferenceInYears(birthDate, currentDate); //calculate the age
	  age = this.truncateAge(age, allowedDecimals); //truncate the age to the allowed number of decimals

	  const decimalsInAge = this.countDecimals(age);
	  // If the age has no decimals and decimals are allowed, add a decimal point and zeros
	  if (decimalsInAge === 0 && allowedDecimals > 0) {
		age += '.';
		for (let i = 0; i < allowedDecimals; i++) {
			age += '0';
		}
		return age;
	  }

	  // If the calculated age has lesser decimals than allowed, add zeros to the right
	  if (decimalsInAge < allowedDecimals) {
		const zerosToAdd = allowedDecimals - decimalsInAge;
		for (let i = 0; i < zerosToAdd; i++) {
			age += '0';
		}
	  }
	  return age;
	}


	calculateDifferenceInYears(birthDate, toDate) {
		// Check for invalid dates
		if (isNaN(birthDate.getTime()) || isNaN(toDate.getTime())) {
			return -1;
		}
	
		// Clone the toDate and set the time to midnight
		const toCopy = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
	
		// Get the last birthday
		let fullYears = toCopy.getFullYear() - birthDate.getFullYear();
		const lastBirthday = new Date(birthDate);
		lastBirthday.setFullYear(lastBirthday.getFullYear() + fullYears);
	
		// If the last birthday is still in the future, move it one year back
		if (lastBirthday > toCopy) {
			lastBirthday.setFullYear(lastBirthday.getFullYear() - 1);
			fullYears--;
		}
		
		// Get the next birthday
		const nextBirthday = new Date(lastBirthday);
		nextBirthday.setFullYear(lastBirthday.getFullYear() + 1);
	
		// Calculate the number of days in the current year (between last and next birthday)
		const daysInCurrentYear = Math.round((nextBirthday - lastBirthday) / (1000 * 60 * 60 * 24));
	
		// Calculate the number of days passed since last birthday
		const daysOfCurrentYearPassed = Math.round((toCopy - lastBirthday) / (1000 * 60 * 60 * 24));
	
		// Calculate the exact age as a floating point number
		const exactAge = fullYears + (daysOfCurrentYearPassed / daysInCurrentYear);
	
		return exactAge;
	}

	truncateAge(age, decimalPlaces) {
		// Multiply by 10^decimalPlaces to shift decimal point
		const temp = age * Math.pow(10, decimalPlaces);
	
		// Floor the number to truncate decimal part
		const tempInteger = Math.floor(temp);
	
		// Divide by 10^decimalPlaces to bring the decimal point back
		return tempInteger / Math.pow(10, decimalPlaces);
	}

	validateFormat(inputValue, field) {
		const matches = inputValue.match(field.format);

		return !matches ? false : true;
	}
	
	validateRange(field, val) {
		const min = Number(field.minimumValue);

		const max = Number(field.maximumValue);
		
		const inputVal = Number(val);
		
		return (inputVal >= min && inputVal <= max);
	}

	dateIsInFuture(dateString) {
		if (!dateString) {
			return true;
		}
		const dob = this.parseDate(dateString);
		const now = new Date();
		const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

		return dob >= tomorrow;
	}

	parseDate(s) {
		const months = {
			jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
			jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
		};

		const p = s.split('-');
		
		if (p.length === 3) {
			return new Date(p[2], months[p[1].toLowerCase()], p[0]);
		} else if (p.length === 2) {
			return new Date(p[1], months[p[0].toLowerCase()], 1);
		} else if (p.length === 1) {
			return new Date(p[0], 0, 1);
		}
		return null;
	}

	isCreatingSubject() {
		return this.selectedSubject === null || (this.selectedSubject && this.selectedSubject.subjectId) === null;
	}

	getFieldConfig(id) {
		const field = this.subjectFields.find((f) => {
			return (+(f.id) === id); //the f.id is string and id is number so using + to convert to number
		});
		return field;
	}

	resetDemographics() {
		
		this.initialsOptions = null;
		this.initialsValue = null;

		this.dobOptions = null;
		this.dobValue = null;

		this.subjectIdOptions = null;
		this.subjectIdValue = null;

		this.subjectId2Options = null;
		this.subjectId2Value = null;

		this.ethnOptions = null;
		this.selectedEthn = null;

		this.genderOptions = null;
		this.selectedGender = null;

		this.ageOptions = null;
		this.ageValue = null;

		this.heightOptions = null;
		this.heightValue = null;

		this.weightOptions = null;
		this.weightValue = null;
		this.weightInKgValue = null;
		this.weightInLbsValue = null;

		this.dobForAgeOptions = null;
		this.dobForAgeValue = null;
	}
}
/* eslint-enable no-underscore-dangle */
export default SubjectManagerPopupController;
